<template>
  <div class="oms-graph-container oms-proff-element">
    <div
      id="investor-chart"
      class="oms-investor-chart related-oms-by-tag"
    />
  </div>
</template>

<script setup lang="ts">

const props = defineProps({
  ticker: {
    type: String,
    required: true
  }
});

useHead({
  script: [{
    key: 'investor-chart',
    src: 'https://dninvestor.azureedge.net/articlechart/js-2.js',
    onload: () => {
      window.DnInvestor.drawChart('investor-chart', props.ticker);
    }
  }]
});
</script>
